import React from 'react';

const DatenschutzModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-brand-dark/95 backdrop-blur-md"
      onClick={onClose}
    >
      <div 
        className="relative w-full max-w-4xl max-h-[90vh] overflow-y-auto bg-white rounded-3xl shadow-2xl animate-scale-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white border-b border-brand-dark/10 px-8 py-6 flex items-center justify-between rounded-t-3xl z-10">
          <h2 className="font-marcellus text-3xl text-brand-dark">Datenschutzerklärung</h2>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-full bg-brand-dark/5 hover:bg-brand-dark/10 flex items-center justify-center transition-colors"
            aria-label="Schließen"
          >
            <svg className="w-6 h-6 text-brand-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="px-8 py-8 font-work text-brand-dark/80 space-y-6">
          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">1. Verantwortlicher</h3>
            <p className="leading-relaxed mb-4">
              Verantwortlich für die Datenverarbeitung auf dieser Website ist:
            </p>
            <p className="leading-relaxed">
              Alexander Suslov<br />
              Im Grünen 17<br />
              24576 Bad Bramstedt<br />
              Deutschland
            </p>
            <p className="mt-4 leading-relaxed">
              <strong>Telefon:</strong> +49 174 7015283<br />
              <strong>E-Mail:</strong> <a href="mailto:info@bodyharmonic.de" className="text-brand-gold hover:underline">info@bodyharmonic.de</a>
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">2. Allgemeine Hinweise zur Datenverarbeitung</h3>
            <p className="leading-relaxed mb-4">
              Der Schutz Ihrer personenbezogenen Daten ist mir ein wichtiges Anliegen.
              Ich behandle Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften (DSGVO) sowie dieser Datenschutzerklärung.
            </p>
            <p className="leading-relaxed">
              Die Nutzung dieser Website ist grundsätzlich ohne Angabe personenbezogener Daten möglich.
              Personenbezogene Daten werden nur erhoben, wenn Sie diese freiwillig mitteilen (z. B. im Rahmen einer Terminbuchung).
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">3. Ihre Rechte nach der DSGVO</h3>
            <p className="leading-relaxed mb-4">Sie haben jederzeit das Recht auf:</p>
            <ul className="list-disc pl-6 space-y-2 leading-relaxed">
              <li>Auskunft über Ihre gespeicherten personenbezogenen Daten (Art. 15 DSGVO)</li>
              <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
              <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
              <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
              <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
              <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
            </ul>
            <p className="leading-relaxed mt-4">
              Zudem haben Sie das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren.
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">4. Hosting und technische Infrastruktur</h3>
            <p className="leading-relaxed mb-4">
              Diese Website wird über Cloudflare Pages betrieben, einen Dienst der:
            </p>
            <p className="leading-relaxed mb-4">
              Cloudflare Inc.<br />
              101 Townsend St<br />
              San Francisco, CA 94107<br />
              USA
            </p>
            <p className="leading-relaxed mb-4">
              Cloudflare stellt eine Content-Delivery-Network-(CDN)-Infrastruktur zur Verfügung, über die diese Website ausgeliefert wird.
            </p>
            <p className="leading-relaxed mb-4">
              Dabei werden technisch notwendige Daten (z. B. IP-Adresse, Browserinformationen) verarbeitet, um die Website sicher und effizient bereitzustellen.
            </p>
            <p className="leading-relaxed mb-4">
              <strong>Rechtsgrundlage:</strong><br />
              Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem sicheren und stabilen Betrieb der Website)
            </p>
            <p className="leading-relaxed">
              Ein Auftragsverarbeitungsvertrag (AVV) mit Cloudflare kann im Cloudflare-Konto abgeschlossen werden.
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">5. SSL- bzw. TLS-Verschlüsselung</h3>
            <p className="leading-relaxed mb-4">
              Diese Website nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung.
              Eine verschlüsselte Verbindung erkennen Sie an „https://" in der Adresszeile Ihres Browsers.
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">6. Terminbuchung über TidyCal</h3>
            <p className="leading-relaxed mb-4">
              Für die Online-Terminbuchung wird ein externer Dienst verwendet:
            </p>
            <p className="leading-relaxed mb-4">
              <strong>TidyCal (Saran Labs LLC)</strong>
            </p>
            <p className="leading-relaxed mb-4">
              Wenn Sie einen Termin buchen, werden die von Ihnen eingegebenen Daten (z. B. Name, E-Mail-Adresse, ggf. Telefonnummer) direkt an TidyCal übermittelt und dort verarbeitet.
            </p>
            <p className="leading-relaxed mb-4">
              Die Verarbeitung erfolgt ausschließlich zur Bearbeitung Ihrer Terminanfrage.
            </p>
            <p className="leading-relaxed mb-4">
              <strong>Rechtsgrundlage:</strong><br />
              Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen)<br />
              Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an effizienter Terminorganisation)
            </p>
            <p className="leading-relaxed">
              Die Speicherdauer richtet sich nach den Richtlinien von TidyCal bzw. den Einstellungen des Kontoinhabers.
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">7. Cookies</h3>
            <p className="leading-relaxed mb-4">
              Diese Website verwendet ausschließlich technisch notwendige Cookies, die für den Betrieb der Website erforderlich sind.
            </p>
            <p className="leading-relaxed mb-4">
              Es werden keine Marketing-, Tracking- oder Analyse-Cookies eingesetzt.
            </p>
            <p className="leading-relaxed mb-4">
              <strong>Rechtsgrundlage:</strong><br />
              Art. 6 Abs. 1 lit. f DSGVO
            </p>
            <p className="leading-relaxed">
              Sie können Cookies jederzeit über die Einstellungen Ihres Browsers deaktivieren.
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">8. Einbindung von YouTube-Videos</h3>
            <p className="leading-relaxed mb-4">
              Auf dieser Website sind Videos des Anbieters YouTube (Google Ireland Limited) eingebunden.
            </p>
            <p className="leading-relaxed mb-4">
              Die Videos werden erst nach aktivem Klick geladen.
              Erst dann wird eine Verbindung zu den Servern von YouTube hergestellt.
            </p>
            <p className="leading-relaxed mb-4">
              Dabei kann YouTube Informationen über Ihre Nutzung dieser Website erhalten.
            </p>
            <p className="leading-relaxed">
              <strong>Rechtsgrundlage:</strong><br />
              Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an ansprechender Darstellung von Inhalten)
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">9. Google Fonts</h3>
            <p className="leading-relaxed mb-4">
              Auf dieser Website werden Schriftarten (Google Fonts) verwendet.
            </p>
            <p className="leading-relaxed mb-4">
              Aktuell werden diese über Server von Google geladen. Dabei kann Ihre IP-Adresse an Google übermittelt werden.
            </p>
            <p className="leading-relaxed mb-4">
              <strong>Hinweis:</strong><br />
              Es ist geplant, die Schriftarten zukünftig lokal zu hosten, um eine Datenübertragung an Google zu vermeiden.
            </p>
            <p className="leading-relaxed">
              <strong>Rechtsgrundlage:</strong><br />
              Art. 6 Abs. 1 lit. f DSGVO
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">10. Datenübermittlung in Drittstaaten</h3>
            <p className="leading-relaxed mb-4">
              Durch die Nutzung externer Dienste (Cloudflare, Google/YouTube, TidyCal) kann es zu einer Übermittlung personenbezogener Daten in Drittstaaten (z. B. USA) kommen.
            </p>
            <p className="leading-relaxed">
              Diese Übermittlung erfolgt auf Grundlage geeigneter Garantien (z. B. Standardvertragsklauseln).
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">11. Art der angebotenen Leistungen</h3>
            <p className="leading-relaxed mb-4">
              Die auf dieser Website angebotenen Leistungen dienen der Prävention, Entspannung und allgemeinen Förderung des Wohlbefindens.
            </p>
            <p className="leading-relaxed">
              Es erfolgt keine medizinische Diagnose, Therapie oder Heilbehandlung.
            </p>
          </section>

          <section>
            <h3 className="font-marcellus text-xl text-brand-dark mb-3">12. Änderung dieser Datenschutzerklärung</h3>
            <p className="leading-relaxed">
              Ich behalte mir vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default DatenschutzModal;
